export default "__VITE_ASSET__BcVUgs9y__"